export const FETCH_PROGRAM_CAP = 'programDataFetch'
export const EDIT_PROGRAM_CAP = 'programDataUpdate'

export const EDIT_PRINT_CAP = 'printDataUpdate'
export const EDIT_MULISITE_SELECTOR_CAP = 'multisiteSelectorDataUpdate'

export const EDIT_NEWSLETTER_CAP = 'newsletterDataUpdate'

export const GET_EVENT_CAP = 'eventDataGet'
export const EDIT_EVENT_CAP = 'eventDataUpdate'
export const DELETE_EVENT_CAP = 'eventDataDelete'